export const HEADER = 'header';
export const SIDEBAR = 'sidebar';
export const FOOTER = 'footer';
export const LOGINPAGE = 'loginpage';